import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from "./services/auth-guard.service";


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},

  {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule),
  },

 
  {
    path: 'dia-zero',
    loadChildren: () => import('./dia-zero/dia-zero.module').then( m => m.DiaZeroPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'dia',
    loadChildren: () => import('./dia/dia.module').then( m => m.DiaPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'misreportes',
    loadChildren: () => import('./misreportes/misreportes.module').then( m => m.MisreportesPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'kpi',
    loadChildren: () => import('./kpi/kpi.module').then( m => m.KPIPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'modal-dataset',
    loadChildren: () => import('./modal-dataset/modal-dataset.module').then( m => m.ModalDatasetPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-upload',
    loadChildren: () => import('./modal-upload/modal-upload.module').then( m => m.ModalUploadPageModule)
  },
  {
    path: 'reporte-diario',
    loadChildren: () => import('./reporte-diario/reporte-diario.module').then( m => m.ReporteDiarioPageModule)
  },
  {
    path: 'modal-comentarios',
    loadChildren: () => import('./modal-comentarios/modal-comentarios.module').then( m => m.ModalComentariosPageModule)
  },
  {
    path: 'reporte-diario-v2',
    loadChildren: () => import('./reporte-diario-v2/reporte-diario-v2.module').then( m => m.ReporteDiarioV2PageModule)
  },
  {
    path: 'reporte-diario-v3',
    loadChildren: () => import('./reporte-diario-v3/reporte-diario-v3.module').then( m => m.ReporteDiarioV3PageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
